import { connect } from 'react-redux';
import { path } from 'ramda';

import {
  toggleNotificationPoint,
  togglePointEditingState,
  saveNotificationPoint,
  confirmNotificationPointCode,
  resetNotificationPointCodeValidation,
  sendNotificationPointCode,
  toggleConfirmationCodePopup,
  fetchPoints as refreshAction,
} from './actions';

import NotificationPoints from '../../../../components/NotificationPoints';

function mapStateToProps(state) {
  return {
    notificationPoints: path(['homePoints', 'points'], state.settings.notifications),
    error: path(['homePoints', 'pointsFetchingError'], state.settings.notifications),
    accountConvergent: path(['homePoints', 'accountConvergent'], state.settings.notifications),
  };
}

const mapDispatchToProps = {
  toggleNotificationPoint,
  togglePointEditingState,
  saveNotificationPoint,
  confirmNotificationPointCode,
  resetNotificationPointCodeValidation,
  sendNotificationPointCode,
  toggleConfirmationCodePopup,
  refreshAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPoints);
